import ShopaholicCart from '@lovata/shopaholic-cart/shopaholic-cart';
import ShopaholicCartPosition from '@lovata/shopaholic-cart/shopaholic-cart-position';
import ShopaholicCartShippingType from '@lovata/shopaholic-cart/shopaholic-cart-shipping-type';

export default class RemoveCardHelper {
  constructor() {
    this.sDefaultButtonClass = '_shopaholic-cart-remove';
    this.sRemoveSelector = this.sDefaultButtonClass;
    this.sRemoveComponentMethod = 'Cart::onRemove';
    this.obAjaxRequestCallback = null;

    ShopaholicCart.instance();
    this.init();
  }

  init() {
    $(document).on('click', `.${this.sRemoveSelector}`, (obEvent) => {
      obEvent.preventDefault();
      const { currentTarget: obButton } = obEvent;
      if (obButton.hasAttribute('disabled')) {
        return;
      }

      this.sendAjaxRequest(obButton);
    });
  }

  sendAjaxRequest(obButton) {
    if (!obButton) {
      throw new Error('Button node is empty.');
    }

    obButton.setAttribute('disabled', 'disabled');
    const obCartPosition = new ShopaholicCartPosition(obButton);
    const iPositionID = obCartPosition.getPositionID();
    const obShippingType = new ShopaholicCartShippingType();

    let obRequestData = {
      data: {
        cart: [iPositionID],
        type: 'position',
        shipping_type_id: obShippingType.getShippingTypeID(),
      },
      complete: ({ responseJSON }) => {
        this.completeCallback(responseJSON, obButton);
      },
    };

    if (this.obAjaxRequestCallback !== null) {
      obRequestData = this.obAjaxRequestCallback(obRequestData, obButton);
    }

    $.request(this.sRemoveComponentMethod, obRequestData);
  }

  // eslint-disable-next-line class-methods-use-this
  completeCallback(obResponse, obButton) {
    const { data: obCartData } = obResponse;

    ShopaholicCart.instance().updateCartData(obCartData);

    if (obButton) {
      obButton.removeAttribute('disabled');
    }
  }

  setAjaxRequestCallback(obCallback) {
    this.obAjaxRequestCallback = obCallback;

    return this;
  }

  setRemoveSelector(sRemoveSelector) {
    this.sRemoveSelector = sRemoveSelector;

    return this;
  }
}
